export default __webpack_public_path__ + "static/media/bdinidjaxxx-color.23ed308b.svg";